// Tanggal hari ini WIB "YYYY-MM-DD" (tidak bergantung zona waktu browser).
export const currentWibDate = () => new Intl.DateTimeFormat("en-CA", { timeZone: "Asia/Jakarta" }).format(new Date());
